import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import axios from 'axios';
import config from '../../config';
import { toast } from 'react-toastify';

function StatusEditModal({ show, onHide, buyerId, initialStatus, initialApproved, onUpdated }) {
  const [status, setStatus] = useState(initialStatus || '');
  const [approved, setApproved] = useState(initialApproved || false);
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.put(`${config.API_BASE_URL}/buyers/${buyerId}`, {
        status,
        approved
      });
      toast.success('Status updated');
      onUpdated();
      onHide();
    } catch (err) {
      toast.error('Failed to update status');
      console.error(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Update Buyer Status</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Status</Form.Label>
            <Form.Select value={status} onChange={(e) => setStatus(e.target.value)} required>
              <option value="">-- Select Status --</option>
              <option value="Active">Active</option>
              <option value="OnHold">On Hold</option>
              <option value="Blocked">Blocked</option>
              <option value="Deactive">Deactive</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Check
              type="switch"
              id="approved-switch"
              label="Buyer is Approved"
              checked={approved}
              onChange={(e) => setApproved(e.target.checked)}
            />
          </Form.Group>

          <div className="d-flex justify-content-end">
            <Button variant="secondary" onClick={onHide} disabled={saving}>
              Cancel
            </Button>
            <Button type="submit" variant="primary" className="ms-2" disabled={saving}>
              {saving ? 'Saving...' : 'Save'}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default StatusEditModal;
